import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import TopNav from "../components/TopNav";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { getLoginContent } from "../lib/loginContent";

export default function LoginPage() {
  const nav = useNavigate();
  const { lang } = useLang();
  const lc = getLoginContent(lang);
  const [email, setEmail] = useState(""); const [pw, setPw] = useState("");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password: pw });
      localStorage.setItem("aabb_token", r.data.access_token);
      localStorage.setItem("aabb_email", r.data.email);
      nav("/account");
    } catch (e) {
      setErr(e?.response?.data?.detail || lc.loginFailed);
    } finally { setBusy(false); }
  };
  return (
    <>
      <TopNav />
      <div className="aa-shell aa-center" style={{
        maxWidth: 480,
        paddingTop: "clamp(60px, 15vh, 100px)",
        paddingInline: "20px",
      }}>
        <h1 className="aa-h1">{lc.signIn}</h1>
        <p className="aa-sub" style={{marginInline: "auto"}}>{lc.subtitle}</p>
        <form onSubmit={submit} style={{width: "100%", maxWidth: "400px", marginInline: "auto"}}>
          <label className="aa-label">{lc.email}</label>
          <input className="aa-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required data-testid="login-email"/>
          <div style={{height:12}}/>
          <label className="aa-label">{lc.password}</label>
          <input className="aa-input" type="password" value={pw} onChange={(e)=>setPw(e.target.value)} required data-testid="login-password"/>
          {err && <div className="aa-error" data-testid="login-error">{err}</div>}
          <div className="aa-bottom" style={{justifyContent: "center"}}>
            <button className="aa-btn" disabled={busy} data-testid="login-submit">{busy ? lc.signingIn : lc.signIn}</button>
          </div>
        </form>
        <p className="aa-caption" style={{marginTop:18, textAlign: "center"}}>
          {lc.newCustomer}{" "}
          <Link to="/intake/start">{lc.startEligibility}</Link>.
        </p>
      </div>
    </>
  );
}
